import React from 'react';
import {Card} from "../../../styledComponents";
import Linkify from 'react-linkify';
import Parser from 'html-react-parser';


const ThxBox = ({greetings}) => {
    const {thankYou, details, ps} = greetings;
    const parsedDetails = details.replace(/\[url='([^\]]+)'\]\s*(.*?)\s*\[\/url\]/ig, '<a href="$1" target="_blank">$2</a>');
    return (
        <Card
        title={thankYou}
        >
            <div style={{whiteSpace:"pre-line"}}>
            <Linkify>
                {Parser(parsedDetails)}

            </Linkify>
            </div>

            <hr />
            {ps}

        </Card>
    )
};

export default ThxBox;



// WEBPACK FOOTER //
// ./src/components/Confirmation/components/thxBox.jsx